// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  stringMustBeGreaterThanZero,
  valueIsRequired,
} from 'validators/common/simple'

// required && X > 0
const requiredStringMustBeGreaterThanZero = v => (
  valueIsRequired(v) ||
  stringMustBeGreaterThanZero(v)
)

export default requiredStringMustBeGreaterThanZero
